/**
 * BLWCK — Sticky Add to Cart Bar
 * Mobile-only | Clean, minimal, premium
 *
 * Cart submission: uses form.requestSubmit(submitButton) so Fabric's
 * product-form-component intercepts the submit event, runs handleSubmit(),
 * dispatches CartAddEvent with sections data, and the cart drawer + count
 * update identically to a real customer tap.
 */
(function () {
  'use strict';

  if (window.__blwckStickyAtcInit) return;
  window.__blwckStickyAtcInit = true;

  /* ------------------------------------------------------------------ */
  /* Helpers                                                               */
  /* ------------------------------------------------------------------ */

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(0);
    amount = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'Rs. ' + amount;
  }

  /* ------------------------------------------------------------------ */
  /* State                                                                 */
  /* ------------------------------------------------------------------ */
  var state = {
    variantId: null,
    price: null,
    sizeLabel: null,
    isSoldOut: false,
    isSingleVariant: false
  };

  var bar, priceEl, sizeEl, btnEl, errorEl;

  function getProductData() { return window.blwckProductData || null; }

  function getSelectedVariantId() {
    var input = document.querySelector(
      '[data-type="add-to-cart-form"] input[name="id"],' +
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );
    return input ? (parseInt(input.value, 10) || null) : null;
  }

  function findVariant(variantId) {
    var data = getProductData();
    if (!data || !data.variants) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (data.variants[i].id === variantId) return data.variants[i];
    }
    return null;
  }

  function getSizeLabel() {
    var checked = document.querySelector(
      '.blwck-vp-wrap input[type="radio"]:checked,' +
      '[data-blwck-vp] input[type="radio"]:checked'
    );
    if (checked) {
      var label = document.querySelector('label[for="' + checked.id + '"]');
      if (label) return label.textContent.trim().split('\n')[0].trim() || checked.value || null;
      return checked.value || null;
    }
    var select = document.querySelector('.blwck-vp-wrap select,[data-blwck-vp] select');
    if (select && select.value) return select.options[select.selectedIndex].text.trim();
    return null;
  }

  function checkSingleVariant() {
    var data = getProductData();
    if (!data || !data.variants || data.variants.length !== 1) return false;
    var t = data.variants[0].title;
    return t === 'Default Title' || t === 'default title';
  }

  /* ------------------------------------------------------------------ */
  /* Render                                                                */
  /* ------------------------------------------------------------------ */
  function renderBar() {
    if (!bar) return;
    if (priceEl && state.price !== null) priceEl.textContent = formatMoney(state.price);
    if (sizeEl) {
      if (state.isSingleVariant) {
        sizeEl.textContent = '';
        sizeEl.className = 'blwck-satc__size blwck-satc__size--hidden';
        bar.querySelectorAll('.blwck-satc__divider').forEach(function (d) { d.style.display = 'none'; });
      } else if (state.sizeLabel) {
        sizeEl.textContent = 'Size: ' + state.sizeLabel;
        sizeEl.className = 'blwck-satc__size blwck-satc__size--selected';
      } else {
        sizeEl.textContent = 'Select Size';
        sizeEl.className = 'blwck-satc__size';
      }
    }
    if (btnEl) {
      if (state.isSoldOut) {
        btnEl.textContent = 'Sold Out';
        btnEl.disabled = true;
        btnEl.className = 'blwck-satc__btn blwck-satc__btn--soldout';
      } else {
        btnEl.textContent = 'Add to Cart';
        btnEl.disabled = false;
        btnEl.className = 'blwck-satc__btn';
      }
    }
  }

  function syncState() {
    state.isSingleVariant = checkSingleVariant();
    state.sizeLabel = state.isSingleVariant ? null : getSizeLabel();
    var variantId = getSelectedVariantId();
    var variant = findVariant(variantId);
    var data = getProductData();
    if (variant) {
      state.variantId = variant.id;
      state.price = variant.price;
      state.isSoldOut = (
        variant.available === false ||
        (variant.inventory_management === 'shopify' &&
         variant.inventory_policy === 'deny' &&
         variant.inventory_quantity <= 0)
      );
    } else if (data && data.variants && data.variants.length > 0) {
      state.price = data.variants[0].price;
      state.variantId = data.variants[0].id;
      state.isSoldOut = false;
    }
    renderBar();
  }

  /* ------------------------------------------------------------------ */
  /* Error / highlight                                                     */
  /* ------------------------------------------------------------------ */
  var errorTimer = null;
  function showError(msg) {
    if (!errorEl) return;
    errorEl.textContent = msg;
    errorEl.classList.add('blwck-satc--show-error');
    clearTimeout(errorTimer);
    errorTimer = setTimeout(function () { errorEl.classList.remove('blwck-satc--show-error'); }, 3000);
  }
  function hideError() { if (errorEl) errorEl.classList.remove('blwck-satc--show-error'); }

  function highlightSizePicker() {
    var picker = document.querySelector('.blwck-vp-wrap, [data-blwck-vp]');
    if (!picker) return;
    picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    picker.classList.add('blwck-highlight');
    setTimeout(function () { picker.classList.remove('blwck-highlight'); }, 1500);
  }

  /* ------------------------------------------------------------------ */
  /* Add to Cart — via form.requestSubmit()                              */
  /*                                                                      */
  /* WHY NOT fetch('/cart/add.js'):                                       */
  /* Calling the Shopify cart REST API directly adds the item server-side */
  /* but fires no JS events. Fabric's cart UI (count bubble, drawer) only */
  /* updates when it receives a 'cart:update' CustomEvent carrying        */
  /* itemCount, source:'product-form-component', and sections HTML.       */
  /* That event is only dispatched by Fabric's own handleSubmit() inside  */
  /* product-form-component — which only runs when the form's 'submit'   */
  /* event fires through the JS event system.                             */
  /*                                                                      */
  /* WHY NOT button.click():                                              */
  /* A programmatic .click() on a submit button does not reliably fire    */
  /* the form's 'submit' event on mobile Safari / Android WebView.        */
  /* The browser's native form submission happens silently, Fabric's      */
  /* on:submit directive never triggers, handleSubmit() never runs.       */
  /*                                                                      */
  /* THE FIX — form.requestSubmit(submitButton):                         */
  /* requestSubmit() is the correct Web standard method. It fires the     */
  /* form's 'submit' event through all JS listeners, with the submitter   */
  /* set to the ATC button so FormData includes name="add". Fabric's      */
  /* on:submit catches it, handleSubmit() runs, fetches with section IDs, */
  /* and dispatches CartAddEvent — cart count increments, drawer opens,  */
  /* fly-to-cart animation plays. Identical to a real customer tap.       */
  /* ------------------------------------------------------------------ */
  function addToCart() {
    if (state.isSoldOut) return;

    if (!state.isSingleVariant && !state.sizeLabel) {
      showError('Please select a size before adding to cart.');
      highlightSizePicker();
      return;
    }

    var variantId = state.variantId || getSelectedVariantId();
    if (!variantId && !state.isSingleVariant) {
      showError('Please select a size before adding to cart.');
      highlightSizePicker();
      return;
    }

    hideError();

    /* Locate the submit button and its form */
    var submitBtn =
      document.querySelector('[data-type="add-to-cart-form"] button[name="add"]') ||
      document.querySelector('product-form-component button[name="add"]') ||
      document.querySelector('form[data-type="add-to-cart-form"] button[type="submit"]');

    var atcForm =
      document.querySelector('form[data-type="add-to-cart-form"]') ||
      (submitBtn && submitBtn.closest('form'));

    if (!atcForm) {
      showError('Something went wrong. Please use the Add to Cart button above.');
      return;
    }

    if (submitBtn && submitBtn.disabled) {
      showError('Please wait a moment and try again.');
      return;
    }

    /* Visual feedback on the sticky button */
    btnEl.classList.add('blwck-satc__btn--loading');
    btnEl.textContent = 'Adding\u2026';

    /* Trigger Fabric's full cart pipeline via the form submit event */
    try {
      if (typeof atcForm.requestSubmit === 'function') {
        atcForm.requestSubmit(submitBtn || undefined);
      } else {
        atcForm.submit();
      }
    } catch (e) {
      try { atcForm.requestSubmit(); } catch (e2) { atcForm.submit(); }
    }

    /* Restore sticky button after Fabric's animation completes */
    setTimeout(function () {
      btnEl.classList.remove('blwck-satc__btn--loading');
      btnEl.textContent = 'Add to Cart';
    }, 2200);
  }

  /* ------------------------------------------------------------------ */
  /* Scroll visibility — show only when scrolled PAST the ATC section    */
  /* ------------------------------------------------------------------ */
  function setupScrollObserver() {
    var target =
      document.querySelector('.add-to-cart-button') ||
      document.querySelector('[data-type="add-to-cart-form"] button[name="add"]') ||
      document.querySelector('product-form-component') ||
      document.querySelector('.buy-buttons-block') ||
      document.querySelector('.blwck-vp-wrap, [data-blwck-vp]');

    if (!target || !bar) return;

    var initialCallbackDone = false;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!initialCallbackDone) { initialCallbackDone = true; return; }
          if (entry.isIntersecting) {
            bar.classList.remove('blwck-satc--visible');
            return;
          }
          var rect = entry.boundingClientRect;
          if (rect.top > 0) {
            bar.classList.remove('blwck-satc--visible');
          } else {
            bar.classList.add('blwck-satc--visible');
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0 }
    );

    observer.observe(target);
  }

  /* ------------------------------------------------------------------ */
  /* Variant change listeners                                              */
  /* ------------------------------------------------------------------ */
  function setupVariantListeners() {
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t.type === 'radio' && (
        t.closest('.blwck-vp-wrap') || t.closest('[data-blwck-vp]') ||
        t.closest('.variant-option') || t.closest('variant-selects') ||
        (t.name && t.name.match(/option/i))
      )) { setTimeout(syncState, 50); }
      if (t.tagName === 'SELECT' && t.closest('.variant-picker, variant-selects')) {
        setTimeout(syncState, 50);
      }
    });
    document.addEventListener('variant:change', function () { setTimeout(syncState, 50); });
    var variantInput = document.querySelector('[data-type="add-to-cart-form"] input[name="id"]');
    if (variantInput) {
      new MutationObserver(function () { setTimeout(syncState, 50); })
        .observe(variantInput, { attributes: true, attributeFilter: ['value'] });
    }
  }

  /* ------------------------------------------------------------------ */
  /* Size cell tap → scroll to picker                                     */
  /* ------------------------------------------------------------------ */
  function setupSizeCellTap() {
    if (sizeEl) sizeEl.addEventListener('click', highlightSizePicker);
  }

  /* ------------------------------------------------------------------ */
  /* Init                                                                  */
  /* ------------------------------------------------------------------ */
  function init() {
    if (!document.querySelector('[data-type="add-to-cart-form"]') &&
        !document.querySelector('product-form-component')) return;
    if (window.innerWidth >= 750) return;

    bar     = document.getElementById('blwck-sticky-atc');
    priceEl = document.getElementById('blwck-satc-price');
    sizeEl  = document.getElementById('blwck-satc-size');
    btnEl   = document.getElementById('blwck-satc-btn');
    errorEl = document.getElementById('blwck-satc-error');
    if (!bar) return;

    syncState();
    setupVariantListeners();
    setupScrollObserver();
    if (btnEl) btnEl.addEventListener('click', addToCart);
    setupSizeCellTap();
  }

  /* ------------------------------------------------------------------ */
  /* Boot                                                                  */
  /* ------------------------------------------------------------------ */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }

  document.addEventListener('shopify:section:load', function () {
    window.__blwckStickyAtcInit = false;
    setTimeout(function () {
      window.__blwckStickyAtcInit = true;
      bar     = document.getElementById('blwck-sticky-atc');
      priceEl = document.getElementById('blwck-satc-price');
      sizeEl  = document.getElementById('blwck-satc-size');
      btnEl   = document.getElementById('blwck-satc-btn');
      errorEl = document.getElementById('blwck-satc-error');
      if (!bar) return;
      syncState();
      setupVariantListeners();
      setupScrollObserver();
      if (btnEl) btnEl.addEventListener('click', addToCart);
      setupSizeCellTap();
    }, 100);
  });

}());
